/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  Stock,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    StockFromJSON,
    StockToJSON,
} from '../models/index';

export interface GetRelatedFileRequest {
    fileName: string;
}

export interface GetStockByEanRequest {
    ean: string;
}

export interface GetStockImageRequest {
    imageName: string;
}

/**
 * 
 */
export class StockControllerApi extends runtime.BaseAPI {

    /**
     */
    async getAllStockRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stock>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stock`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StockFromJSON));
    }

    /**
     */
    async getAllStock(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stock>> {
        const response = await this.getAllStockRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getRelatedFileRaw(requestParameters: GetRelatedFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['fileName'] == null) {
            throw new runtime.RequiredError(
                'fileName',
                'Required parameter "fileName" was null or undefined when calling getRelatedFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stock/file/{fileName}`.replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters['fileName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getRelatedFile(requestParameters: GetRelatedFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getRelatedFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStockByEanRaw(requestParameters: GetStockByEanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stock>> {
        if (requestParameters['ean'] == null) {
            throw new runtime.RequiredError(
                'ean',
                'Required parameter "ean" was null or undefined when calling getStockByEan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stock/{ean}`.replace(`{${"ean"}}`, encodeURIComponent(String(requestParameters['ean']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StockFromJSON(jsonValue));
    }

    /**
     */
    async getStockByEan(requestParameters: GetStockByEanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stock> {
        const response = await this.getStockByEanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStockImageRaw(requestParameters: GetStockImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['imageName'] == null) {
            throw new runtime.RequiredError(
                'imageName',
                'Required parameter "imageName" was null or undefined when calling getStockImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stock/image/{imageName}`.replace(`{${"imageName"}}`, encodeURIComponent(String(requestParameters['imageName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getStockImage(requestParameters: GetStockImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getStockImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
